import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchCommonDataAcademy extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { education_type_id, ministry_id, province_id, th_name, status } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">          
                        <Row className="mt-3">
                            <Col md={5}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{education_type_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={education_type_id}
                                        option={{source: 'db', data: Masterbase?.education_type}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{ministry_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={ministry_id}
                                        option={{source: 'db', data: Masterbase?.ministry}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <Row> 
                            <Col md={5}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{th_name.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={th_name}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!['0', '1'].includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col> 
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{province_id.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={province_id}
                                        option={{source: 'db', data: Masterbase?.province}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)}
                                    />
                                </InputGroup>
                            </Col>                                           
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'default'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={1}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                            <Col md={3}></Col>  
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchCommonDataAcademy;